import { combineReducers } from 'redux';
import { reducer as toastr } from 'react-redux-toastr';

import api                    from './api';
import assignments            from './assignments';
import enterpriseMaintenance  from './enterpriseMaintenance';
import features               from './features';
import forgotStatus           from './forgotStatus';
import generalInfo            from './generalInfo';
import licenses               from './licenses';
import loading                from './loading';
import loggedIn               from './loggedIn';
import messageBox             from './messageBox';
import permissions            from './permissions';
import question               from './question';
import repeatTester           from './repeatTester';
import roles                  from './roles';
import utilities              from './utilities';

const momApp = combineReducers({
  api,
  assignments,
  enterpriseMaintenance,
  features,
  forgotStatus,
  generalInfo,
  licenses,
  loading,
  loggedIn,
  messageBox,
  permissions,
  question,
  repeatTester,
  roles,
  toastr,
  utilities,
});

export default momApp;



// WEBPACK FOOTER //
// ./src/reducers/MOM.js